import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';

import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";

import './css/Form.css';
import RealexHpp from "../../../../../rxp-js";

class Add extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        }
    }

    saveCardReference = (hppResponse) => {
        axios.post(`/cards`,{ hppResponse:hppResponse })
            .then(response => {
                this.props.refreshCardsList();
                this.props.handleNewCardAdded('success', this.props.t('saved_cards.messages.add_success'))
            })
            .catch(error => {
                this.props.handleNewCardAdded('error', this.props.t('saved_cards.messages.add_error'))
            });
    }

    async componentDidMount() {

        axios.post(`/globalpayment/getVerifyToken`,{amount: this.state.amount,sub_account:this.state.sub_account})
            .then(response => {
                this.setState({loading:false});

                RealexHpp.setHppUrl(PAYMENT_HPP_URL);
                RealexHpp.embedded.init(
                    "autoload",
                    "cardAddFrame",
                    function(response,close){
						if(!(response.error)){
							if(response.AUTHCODE){
								this.saveCardReference(response);
								close();
							}
							else{
								this.props.handleNewCardAdded('error', this.props.t('saved_cards.messages.add_error'))
							}
						}
                    }.bind(this),
                    response.data,
                    {
                        onResize:function(data){
                            $('#targetIframe').css(data)
                        }
                    }
                );
                setTimeout(function(){
                    this.setState({loading:false})
                    $('#global-pay-container').show();
                }.bind(this),1000)

            }).catch(error => {
            console.log('[AccountsList.js] : Favorites ajax error in addRemoveFavoriteHandler()',error.message);
        });
    }

    render() {
        const {loading} = this.state;

        return (
            <div className="container container--larger">
                {loading ?
                    <Spinner />:
                    <div id={'global-pay-container'}>
                        <iframe id="cardAddFrame">
                        </iframe>
                    </div>}
            </div>
        );
    }
}

export default withTranslation()(Add);
